import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { SUPPORTED_LANGS } from "../i18n";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

/**
 * Flag dropdown in the Header next to the theme toggle. Surfaces the 4
 * supported languages with their native names so a Yorùbá speaker can
 * recognise "Yorùbá" without needing to know the ISO code.
 */
export default function LanguagePicker({ className = "" }) {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = SUPPORTED_LANGS.find((l) => l.code === i18n.language)
    || SUPPORTED_LANGS[0];

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={t("header.language")}
          title={t("header.language")}
          data-testid="language-picker"
          className={`inline-flex items-center gap-1.5 h-8 px-2 rounded-sm border border-gray-300 dark:border-zinc-700 bg-white dark:bg-zinc-900 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-zinc-800 ${className}`}
        >
          <Languages className="w-3.5 h-3.5" />
          <span className="text-[11px] font-bold font-body uppercase tracking-wider">
            {current.code}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[8rem]">
        {SUPPORTED_LANGS.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            data-testid={`language-option-${lang.code}`}
            onClick={() => i18n.changeLanguage(lang.code)}
            className={`text-sm font-body cursor-pointer ${
              i18n.language === lang.code ? "font-bold" : ""
            }`}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
